import AdminHeader from "components/Headers/AdminHeader";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { SELECT_CUSTOM_STYLES } from "constants/CommonConstants";
import Select from "react-select";
import { coursesList, MODULES, instructorsList, OFFLINE_TRAINING_CENTER } from "components/constant";
import ReactQuill from "react-quill";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import InfoPopover from "components/CommonComponents/InfoPopover";
import DatePicker from "react-datepicker";

//static data for batch in edit mode
const staticBatchData = [
  {
    id: 1,
    courseName: "Electrical Safety",
    sessionName: "Morning Batch",
    batchStartDate: "2026-04-10",
    batchEndDate: "2026-05-10",
    batchStartTime: "10:00",
    batchEndTime: "12:00",
    NoOfTrainer: "2",
    Trainers: ["John Doe", "Jane Smith"],
    offlineTrainingCenter: "Pune Industrial Training Center",
    minParticipant: "15",
    maxParticipant: "30",
    batchDescription:
      "<p>This batch covers essential electrical safety practices including hazard identification, use of protective equipment, and safe handling of electrical systems. Ideal for beginners and field technicians.</p>",
  },
  {
    id: 2,
    courseName: "Power Systems Advanced",
    sessionName: "Evening Batch",
    batchStartDate: "2026-04-15",
    batchEndDate: "2026-05-20",
    batchStartTime: "15:00",
    batchEndTime: "17:00",
    NoOfTrainer: "1",
    Trainers: ["Mike Johnson"],
    offlineTrainingCenter: "Bangalore Skill Hub",
    minParticipant: "20",
    maxParticipant: "30",
    batchDescription:
      "<p>This advanced course focuses on power system analysis, load flow studies, fault analysis, and system stability. Suitable for experienced engineers looking to deepen their knowledge.</p>",
  },
  {
    id: 3,
    courseName: "Industrial Wiring Basics",
    sessionName: "Weekend Batch",
    batchStartDate: "2026-04-12",
    batchEndDate: "2026-06-01",
    batchStartTime: "09:00",
    batchEndTime: "11:00",
    NoOfTrainer: "2",
    Trainers: ["John Doe", "Mike Johnson"],
    offlineTrainingCenter: "Delhi Technical Academy",
    minParticipant: "10",
    maxParticipant: "25",
    batchDescription:
      "<p>This weekend batch introduces the fundamentals of industrial wiring, including circuit design, wiring standards, tools usage, and troubleshooting techniques for real-world applications.</p>",
  },
];

const initialFields = {
  courseName: {
    value: "",
    error: "",
  },
  sessionName: {
    value: "",
    error: "",
    isChanged: false,
  },
  batchStartDate: {
    value: "",
    error: "",
    isChanged: false,
  },
  batchEndDate: {
    value: "",
    error: "",
    isChanged: false,
  },
  batchStartTime: {
    value: "",
    error: "",
    isChanged: false,
  },
  batchEndTime: {
    value: "",
    error: "",
    isChanged: false,
  },
  NoOfTrainer: {
    value: "",
    error: "",
    isChanged: false,
  },
  Trainers: {
    value: [], //multi -> array
    error: "",
    isChanged: false,
  },
  batchDescription: {
    value: "",
    error: "",
    isChanged: false,
  },
  offlineTrainingCenter: {
    value: "",
    error: "",
    isChanged: false,
  },
  minParticipant: {
    value: "",
    error: "",
    isChanged: false,
  },
  maxParticipant: {
    value: "",
    error: "",
    isChanged: false,
  },
};

function AddBatch() {
  const { id } = useParams();
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const decodedId = id ? urlDecodedId(id) : null;
  const navigate = useNavigate();
  // const location = useLocation();
  // const mode = location.state?.mode || "add";
  const mode = id ? "edit" : "add";
  const [formData, setFormData] = useState(initialFields);

  useEffect(() => {
    if (decodedId) {
      const selectedBatch = staticBatchData.find(
        (item) => item.id === Number(decodedId),
      );
      const data = selectedBatch || staticBatchData[0];
      setFormData({
        courseName: {
          value: data.courseName,
          error: "",
        },
        sessionName: {
          value: data.sessionName,
          error: "",
          isChanged: false,
        },
        batchStartDate: {
          value: data.batchStartDate,
          error: "",
          isChanged: false,
        },
        batchEndDate: {
          value: data.batchEndDate,
          error: "",
          isChanged: false,
        },
        batchStartTime: {
          value: data.batchStartTime,
          error: "",
          isChanged: false,
        },
        batchEndTime: {
          value: data.batchEndTime,
          error: "",
          isChanged: false,
        },
        NoOfTrainer: {
          value: data.NoOfTrainer,
          error: "",
          isChanged: false,
        },
        Trainers: {
          value: data.Trainers,
          error: "",
          isChanged: false,
        },
        batchDescription: {
          value: data.batchDescription,
          error: "",
          isChanged: false,
        },
        offlineTrainingCenter: {
          value: data.offlineTrainingCenter,
          error: "",
          isChanged: false,
        },
        minParticipant: {
          value: data.minParticipant,
          error: "",
          isChanged: false,
        },
        maxParticipant: {
          value: data.maxParticipant,
          error: "",
          isChanged: false,
        },
      });
    }
  }, [decodedId]);

  const handleOnBlur = (name, value) => {
    const trimmed = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmed, formData);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmed,
        error,
      },
    }));
  };

  const getValidationError = (field, value, formData) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (field) {
      case "courseName":
        return !trimmedValue ? "Please select course name" : "";

      case "sessionName":
        return !trimmedValue ? "Please enter session name" : "";

      case "batchStartDate":
        return !trimmedValue ? "Please select start date" : "";

      case "batchEndDate":
        return !trimmedValue ? "Please select end date" : "";

      case "batchStartTime":
        return !trimmedValue ? "Please select start time" : "";

      case "batchEndTime":
        return !trimmedValue ? "Please select end time" : "";

      case "NoOfTrainer":
        if (!trimmedValue) return "Please enter number of instructors";
        if (!/^\d+$/.test(trimmedValue)) return "Enter a valid number";
        return "";

      case "Trainers":
        if (!value || value.length === 0) {
          return "Please select at least one instructor";
        }
        const noOfTrainers = parseInt(formData.NoOfTrainer.value, 10);
        if (value.length !== noOfTrainers) {
          return `Please select exactly ${noOfTrainers} instructor(s)`;
        }
        return "";

      case "batchDescription":
        return !trimmedValue ? "Please enter batch description" : "";

      default:
        return "";
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => {
      let updated = {
        ...prev,
        [field]: {
          ...prev[field],
          value,
          error: "",
          isChanged: true,
        },
      };
      // Reset trainers if NoOfTrainer changes
      if (field === "NoOfTrainer") {
        updated.Trainers = {
          ...updated.Trainers,
          value: [],
          error: "",
          isChanged: true,
        };
      }

      return updated;
    });
  };

  const courseOptions = coursesList.map((course) => ({
    value: course.title,
    label: course.title,
  }));

  const instructorOptions = instructorsList.map((instructor) => ({
    value: instructor.fullName,
    label: instructor.fullName,
  }));

  const validateForm = () => {
    let newCategory = { ...formData };

    Object.keys(newCategory).forEach((key) => {
      newCategory[key] = {
        ...newCategory[key],
        error: getValidationError(key, newCategory[key].value, newCategory),
      };
    });

    setFormData(newCategory);
    return Object.values(newCategory).every((item) => item.error === "");
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    navigate(role === "SUPER_ADMIN" ? "/super-admin/batch" : "/admin/batch");
  };

  return (
    <>
      <AdminHeader parentName="Batch" />
      <Container className="mt--6" fluid>
        <Card className="mb-4">
          <CardHeader className="d-flex align-items-center ">
            <i
              className="fa fa-chevron-left mr-2 cursor"
              onClick={() =>
                navigate(
                  role === "SUPER_ADMIN"
                    ? "/super-admin/batch"
                    : "/admin/batch",
                )
              }
            />
            <h3 className="mb-0">
              {mode === "edit" ? "Edit Batch" : "Add Batch"}
            </h3>
          </CardHeader>

          <CardBody>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">Course Name </Label>
                  <span className="text-danger"> *</span>
                  <Select
                    name="courseName"
                    options={courseOptions}
                    placeholder="Select course name"
                    styles={SELECT_CUSTOM_STYLES}
                    classNamePrefix="react-select"
                    value={
                      formData.courseName.value
                        ? {
                          value: formData.courseName.value,
                          label: formData.courseName.value,
                        }
                        : null
                    }
                    onChange={(selected) =>
                      handleChange("courseName", selected ? selected.value : "")
                    }
                    onBlur={() =>
                      handleOnBlur("courseName", formData.courseName.value)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    className={formData.courseName.error ? "is-invalid" : ""}
                  />
                  {formData.courseName.error && (
                    <div className="invalid-feedback d-block">
                      {formData.courseName.error}
                    </div>
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Session Name <span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="text"
                    name="sessionName"
                    value={formData.sessionName.value}
                    onChange={(e) =>
                      handleChange("sessionName", e.target.value)
                    }
                    placeholder="Enter session name"
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.sessionName.error ? "is-invalid" : ""}
                  />
                  {formData.sessionName.error && (
                    <small className="invalid-feedback d-block">
                      {formData.sessionName.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="2">
                <FormGroup>
                  <Label className="form-control-label">
                    Start Date <span className="text-danger"> *</span>
                  </Label>
                  <DatePicker
                    selected={
                      formData.batchStartDate.value
                        ? new Date(formData.batchStartDate.value)
                        : null
                    }
                    onChange={(date) => handleChange("batchStartDate", date)}
                    onBlur={() => handleOnBlur("batchStartDate", formData.batchStartDate.value)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="YYYY-MM-DD"
                    minDate={new Date()}
                    showIcon
                    icon={
                      <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                    }
                    toggleCalendarOnIconClick
                    className={`form-control ${formData.batchStartDate.error ? "is-invalid" : ""
                      }`}
                    wrapperClassName="w-100"
                    calendarClassName="custom-calendar"
                    popperPlacement="bottom-start"
                    onKeyDown={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                  {formData.batchStartDate.error && (
                    <small className="invalid-feedback d-block">
                      {formData.batchStartDate.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="2">
                <FormGroup>
                  <Label className="form-control-label">
                    End Date<span className="text-danger"> *</span>
                  </Label>
                  <DatePicker
                    selected={
                      formData.batchEndDate.value
                        ? new Date(formData.batchEndDate.value)
                        : null
                    }
                    onChange={(date) => handleChange("batchEndDate", date)}
                    onBlur={() => handleOnBlur("batchEndDate", formData.batchEndDate.value)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="YYYY-MM-DD"
                    minDate={formData.batchStartDate.value}
                    showIcon
                    icon={
                      <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                    }
                    toggleCalendarOnIconClick
                    className={`form-control ${formData.batchEndDate.error ? "is-invalid" : ""
                      }`}
                    wrapperClassName="w-100"
                    calendarClassName="custom-calendar"
                    popperPlacement="bottom-start"
                    onKeyDown={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    style={styles.datePicker}
                  />
                  {formData.batchEndDate.error && (
                    <small className="invalid-feedback d-block">
                      {formData.batchEndDate.error}
                    </small>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="2">
                <FormGroup>
                  <Label className="form-control-label">
                    Start Time<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="time"
                    name="batchStartTime"
                    value={formData.batchStartTime.value}
                    placeholder="Enter start time"
                    onChange={(e) =>
                      handleChange("batchStartTime", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={
                      formData.batchStartTime.error ? "is-invalid" : ""
                    }
                  />
                  {formData.batchStartTime.error && (
                    <small className="invalid-feedback d-block">
                      {formData.batchStartTime.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="2">
                <FormGroup>
                  <Label className="form-control-label">
                    End Time<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="time"
                    name="batchEndTime"
                    value={formData.batchEndTime.value}
                    placeholder="Enter end time"
                    onChange={(e) =>
                      handleChange("batchEndTime", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.batchEndTime.error ? "is-invalid" : ""}
                  />
                  {formData.batchEndTime.error && (
                    <small className="invalid-feedback d-block">
                      {formData.batchEndTime.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Number Of Trainers<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="text"
                    name="NoOfTrainer"
                    value={formData.NoOfTrainer.value}
                    placeholder="Enter number of trainer"
                    maxLength={10}
                    onChange={(e) =>
                      handleChange("NoOfTrainer", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.NoOfTrainer.error ? "is-invalid" : ""}
                  />
                  {formData.NoOfTrainer.error && (
                    <small className="invalid-feedback d-block">
                      {formData.NoOfTrainer.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">Trainers </Label>
                  <span className="text-danger"> *</span>
                  <Select
                    isMulti
                    name="Trainers"
                    options={instructorOptions}
                    placeholder="Select instructor"
                    styles={SELECT_CUSTOM_STYLES}
                    classNamePrefix="react-select"
                    value={
                      formData.Trainers.value.length > 0
                        ? formData.Trainers.value.map((trainer) => ({
                          value: trainer,
                          label: trainer,
                        }))
                        : []
                    }
                    onChange={(selected) =>
                      handleChange(
                        "Trainers",
                        selected ? selected.map((item) => item.value) : [],
                      )
                    }
                    isDisabled={
                      !formData.NoOfTrainer.value ||
                      formData.NoOfTrainer.value <= 0
                    }
                    onBlur={() =>
                      handleOnBlur("Trainers", formData.Trainers.value)
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    className={formData.Trainers.error ? "is-invalid" : ""}
                    isOptionDisabled={() =>
                      formData.Trainers.value.length >=
                      parseInt(formData.NoOfTrainer.value || 0, 10)
                    }
                  />
                  {formData.Trainers.error && (
                    <div className="invalid-feedback d-block">
                      {formData.Trainers.error}
                    </div>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label mt-1">
                    Offline Training Center{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <div className="mt-2">
                    <Select
                      options={OFFLINE_TRAINING_CENTER}
                      placeholder="Select offline training center"
                      styles={SELECT_CUSTOM_STYLES}
                      classNamePrefix="react-select"
                      value={
                        formData.offlineTrainingCenter.value
                          ? {
                            value: formData.offlineTrainingCenter.value,
                            label: formData.offlineTrainingCenter.value,
                          }
                          : null
                      }
                      onChange={(selected) =>
                        handleChange("offlineTrainingCenter", selected)
                      }
                      onBlur={() =>
                        handleOnBlur(
                          "offlineTrainingCenter",
                          formData.offlineTrainingCenter.value,
                        )
                      }
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                  {formData.offlineTrainingCenter.error && (
                    <div className="invalid-feedback d-block">
                      {formData.offlineTrainingCenter.error}
                    </div>
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label mt-1">
                    Min Participants
                    <InfoPopover
                      targetId="minParticipantInfo"
                      title="Min Participants"
                      content="Sets the minimum number of learners who can enroll."
                    />
                  </Label>
                  <div className="mt-2">
                    <Input
                      name="minParticipant"
                      value={formData.minParticipant.value}
                      placeholder="Enter min participants"
                      onChange={(e) =>
                        handleChange("minParticipant", e.target.value)
                      }
                    />
                  </div>
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label mt-1">
                    Max Participants
                    <InfoPopover
                      targetId="maxParticipantsInfo"
                      title="Max Participants"
                      content="Sets the maximum number of learners who can enroll."
                    />
                  </Label>
                  <div className="mt-2">
                    <Input
                      name="maxParticipant"
                      value={formData.maxParticipant.value}
                      placeholder="Enter max participants"
                      onChange={(e) =>
                        handleChange("maxParticipant", e.target.value)
                      }
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="8">
                <FormGroup>
                  <Label className="form-control-label">
                    Description <span className="text-danger"> *</span>
                  </Label>

                  <div
                    className={`quill-wrapper ${formData.batchDescription.error ? "border border-danger rounded" : ""}`}
                  >
                    <ReactQuill
                      theme="snow"
                      modules={MODULES}
                      placeholder="Enter Description"
                      value={formData.batchDescription.value}
                      onChange={(value) =>
                        handleChange("batchDescription", value)
                      }
                      onBlur={() =>
                        handleOnBlur(
                          "batchDescription",
                          formData.batchDescription.value,
                        )
                      }
                    />
                  </div>

                  {formData.batchDescription.error && (
                    <div className="invalid-feedback d-block">
                      {formData.batchDescription.error}
                    </div>
                  )}
                </FormGroup>
              </Col>
            </Row>

            {/* Action Buttons */}
            <Row className="mt-4">
              <Col className="text-right">
                <button
                  className="btn btn-secondary mr-2"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/batch"
                        : "/admin/batch",
                    )
                  }
                >
                  Cancel
                </button>
                <button
                  className="btn btn-deep-blue"
                  color="primary"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default AddBatch;

const styles = {
  datePicker: {
    width: "100%",
    display: "flex",
  },
}